import StaffListFilterIcon from "../../assets/images/StaffListFilterIcon";
import { DashboardConstants } from "../../constants/constants";

const FilterBar = () => {
  return (
    <div className="flex items-center pl-4 w-[117px] h-[40px] cursor-not-allowed staffListDownloadCheckbox text-primary border border-primary rounded-lg">
      {/* <div className="h-2 w-2 bg-sideMenuHelpBox rounded-full mr-2.5"></div> */}
      <StaffListFilterIcon />
      <div className="pl-2.5">{DashboardConstants.filters}</div>
    </div>
  );
};
export default FilterBar;
